import { useNavigate } from 'react-router';
import { z } from 'zod';
import { useSuspenseWebAuthnAuthenticatorsQuery } from '#api/webauthn-authenticators.queries.ts';
import { Modal, ModalHeader } from '#components/patterns/modal/index.ts';
import { useZodParams } from '#hooks/useZodParams.ts';
import { NotFound } from '#screens/404/NotFound.tsx';
import { page, Titled } from '#util/title.ts';
import { EditWebAuthnForm } from './form/EditWebAuthnForm.tsx';

export function EditWebAuthnModal() {
  const { webauthnId } = useZodParams({ webauthnId: z.string() });
  const passkeys = useSuspenseWebAuthnAuthenticatorsQuery().data.data;
  const navigate = useNavigate();

  const passkey = passkeys.find((p) => p.id === webauthnId);

  if (!passkey) {
    return <NotFound />;
  }

  function returnToUserSettings() {
    void navigate('..', { replace: true });
  }

  return (
    <Modal isOpen={true} onClose={returnToUserSettings}>
      <Titled title={() => page('Edit passkey')}>
        <ModalHeader>{`Edit ${passkey.name || 'passkey'}`}</ModalHeader>
        <EditWebAuthnForm
          onSuccess={returnToUserSettings}
          onCancel={returnToUserSettings}
          defaultValues={{ name: passkey.name }}
          webauthnID={passkey.id}
        />
      </Titled>
    </Modal>
  );
}
